import { SettingsNavigation, type SettingsNavigationItem } from './SettingsNavigation'

const ITEMS: SettingsNavigationItem[] = [
  { id: 'settings-tab-bank-customers', label: 'Auftraggeber', to: '/settings/bank' },
  { id: 'settings-tab-bank-advisors', label: 'Berater', to: '/settings/bank/advisors' },
]

export function BankSettingsNav() {
  return <SettingsNavigation items={ITEMS} />
}
